module.exports = __webpack_public_path__ + "img/js.bdcc5bfa.png";